// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderSection-module--wrapper--NjD5X","subtitle":"HeaderSection-module--subtitle--sBlqk","home":"HeaderSection-module--home--3DQDm"};